import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

import { RootContainers } from '@/modules/common/helpers';

export default function MUIPopover(theme: Theme): Components['MuiPopover'] {
  return {
    defaultProps: {
      container: RootContainers.getMUIPortalContainer(),
      disableScrollLock: true,
      elevation: 15,
    },
    styleOverrides: {
      root: {
        marginTop: theme.spacing(0),
      },
    },
  };
}
